/* eslint-disable react/prop-types */
import React from 'react'
import { Form, Input } from 'antd'
import { useController, useFormContext } from 'react-hook-form'
import styled from 'styled-components'

export const WrapperFormItem = styled(Form.Item)`
  height: max-content;
  width: 100%;
  margin-bottom: 10px;

  .ant-form-item-explain {
    display: ${({ disableErrorMessage }) => (disableErrorMessage ? 'none' : 'block')};
  }

  .ant-form-item-label {
    font-size: 14px;
    overflow: unset;
    white-space: unset;

    .ant-form-item-no-colon {
      height: 100%;
    }
  }
`

export const WrapperLabel = styled.div`
  width: 100%;
  font-size: 13px;
`

const FormInput = ({ label, name, rules, defaultValue = '', wrapperProps, placeholder, ...rest }) => {
  const { control } = useFormContext()
  const { field: { onChange, value }, fieldState: { error } } = useController({ name, control, rules, defaultValue })

  return (
    <WrapperFormItem
      {...wrapperProps}
      label={label && <WrapperLabel>{label}</WrapperLabel>}
      validateStatus={(error) ? 'error' : ''}
      help={error?.message}
    >
      <Input name={name} placeholder={placeholder} onChange={onChange} value={value} {...rest} />
    </WrapperFormItem>
  )
}

export default FormInput
